import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
@Pipe({
    name: 'dateDiff',
    standalone: false
})
export class DateDiffPipe implements PipeTransform {
  transform(value: any): any {
    return moment(value).fromNow();
  }
}
